/**
 * Redux internal
 */
import { actionCreators } from './_internal';

export default { ...actionCreators };
